export class GetRuleTypes {
  static type = '[Criterion Addition] Get types';
}
export class GetSupportedCriteria {
  static type = '[Criterion Addition] Get Supported Criteria';
}
